export default {
  SET_SUBMISSION_SUMMARY: 'SET_SUBMISSION_SUMMARY',
  SET_INDICATION_SUMMARY: 'SET_INDICATION_SUMMARY',
  SET_STUDY_SUMMARY: 'SET_STUDY_SUMMARY',
  SET_QCED_GUIDANCE_COMPARE: 'SET_QCED_GUIDANCE_COMPARE',
  SET_NON_QCED_GUIDANCE_COMPARE: 'SET_NON_QCED_GUIDANCE_COMPARE',
  SET_SUBMITTING: 'SET_SUBMITTING',
  SET_SUBMISSION_INDICATIONS: 'SET_SUBMISSION_INDICATIONS'
};
